/**
 * Aide contextuelle — Email Triage
 */

const emailTriageHelp = {
  '/email-triage': {
    title: 'Email Triage',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Configurer le tri automatique des emails reçus sur support@meteris.fr et contact@meteris.fr. Chaque règle classe les emails dans une catégorie (URGENT, SUPPORT, COMMERCIAL, LEAD, etc.) selon des conditions sur le sujet, l'expéditeur ou le corps.`,
      },
      {
        heading: 'Comment ça fonctionne',
        content: `Toutes les 2 minutes, un collecteur automatique :\n1. Récupère les emails non lus via Microsoft Graph\n2. Applique les règles (priorité croissante — 1ère match gagne)\n3. Ajoute un tag Outlook coloré (ex: "Support", "Commercial")\n4. Si l'utilisateur a tag "Support" manuellement → crée un ticket\n5. Si l'utilisateur a tag "Lead" manuellement → crée un lead CRM`,
      },
      {
        heading: 'Créer une règle',
        content: `**+ Nouvelle règle**. Donnez un nom, choisissez la catégorie cible, ajoutez des conditions (sujet contient X / expéditeur = Y / domaine = Z / corps contient W). Combinez avec ET/OU. Priorité = ordre d'évaluation (plus petit = plus prioritaire).`,
      },
      {
        heading: 'Catégories disponibles',
        content: `**URGENT** (rouge), **SUPPORT** (bleu), **COMMERCIAL** (orange), **LEAD** (violet, va en CRM), **ADMINISTRATIF** (vert), **NEWSLETTER**, **SPAM**, **STAGE**, **PARTENARIAT**, **LIVRAISON**, **RESEAUX_SOCIAUX**.`,
      },
      {
        heading: 'Historique',
        content: `Onglet **Historique** : liste des 500 derniers emails traités avec catégorie, action effectuée (ticket_created, lead_created, manual_archived, tagged), délai de traitement.`,
      },
    ],
    admin: [
      {
        heading: 'Architecture',
        content: `Service \`email_collector_svc.py\` — boucle 120s + Microsoft Graph app-only. Règles en MongoDB collection \`email_triage_rules\` (priorité ASC, enabled=true). Log dans \`email_collector_log\` (ttl 90 jours recommandé).`,
      },
      {
        heading: 'Endpoints',
        content: `\`GET/POST/PUT/DELETE /api/email-triage/rules\` — CRUD règles.\n\`POST /api/email-triage/rules/seed\` — Seed pack de règles par défaut.\n\`GET /api/email-triage/rules/export\` — Export JSON pour n8n (public).\n\`GET /api/email-triage/collector/history\` — Log des emails traités.\n\`GET /api/email-triage/collector/stats\` — Stats par action/catégorie.`,
      },
      {
        heading: 'Tags Outlook reconnus',
        content: `**Support** → crée un ticket (support@meteris.fr uniquement, TICKET_MAILBOXES).\n**Lead** → crée un lead CRM avec auto-match client.\n**Archiver** → archive sans action.\n**Supprimer** → supprime définitivement.`,
      },
      {
        heading: 'Permissions',
        content: `\`ticketing.admin\` pour gérer les règles. L'export JSON des règles est public (pour n8n).`,
      },
    ],
  },
};

export default emailTriageHelp;
